/* eslint-disable */ import { DomainEntityReflection, EnumReflection, RawAliasReflection, SchemaReflection } from '@salsita-ai/platform-project-sdk/domain';
export const modelVersion = 1;
export const ThicknessesTypes = new EnumReflection('ThicknessesTypes', {
    enum: [
        'Standard',
        'Thick',
        'Rolled'
    ]
});
export const BaseTypes = new EnumReflection('BaseTypes', {
    enum: [
        'Pedestal',
        'Metal',
        'FourLeg'
    ]
});
export const WoodSpecies = new EnumReflection('WoodSpecies', {
    enum: [
        'Hickory',
        'Ash',
        'Maple',
        'Walnut',
        'QuarterSawnWhiteOak'
    ]
});
export const DistressLevels = new EnumReflection('DistressLevels', {
    enum: [
        'Clean',
        'Minimal',
        'Light',
        'Medium',
        'Heavy',
        'RoughSawn'
    ]
});
export const EdgeStyles = new EnumReflection('EdgeStyles', {
    enum: [
        'Clean',
        'NaturalWavy',
        'Tumbled',
        'Dupont',
        'Beveled'
    ]
});
export const Finishes = new EnumReflection('Finishes', {
    enum: [
        'BlackTone',
        'EbonyTone',
        'Gray',
        'DarkBrownTone',
        'MediumBrownTone',
        'LightBrownTone',
        'NaturalTone',
        'Earthtone',
        'Taupe',
        'Custom'
    ]
});
export const SheenTypes = new EnumReflection('SheenTypes', {
    enum: [
        'Flat',
        'Satin'
    ]
});
export const LeafTypes = new EnumReflection('LeafTypes', {
    enum: [
        'NoLeaf',
        'Standard',
        'Medium',
        'Large',
        'Perimeter',
        'StandardDropIn',
        'MediumDropIn',
        'LargeDropIn',
        'CustomLeaf'
    ]
});
export const SeatingTypes = new EnumReflection('SeatingTypes', {
    enum: [
        'NoSeating',
        'Benches',
        'Chairs',
        'ChairsAndBenches'
    ]
});
export const CrossbraceTypes = new EnumReflection('CrossbraceTypes', {
    enum: [
        'StandardCrossbrace',
        'NotchedCrossbrace'
    ]
});
const TableShape = new SchemaReflection('TableShape', {
    type: 'object',
    properties: {
        topId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        },
        baseStyleId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        },
        benchId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        },
        baseType: BaseTypes._meta.schema,
        woodSpecies: WoodSpecies._meta.schema,
        sheen: SheenTypes._meta.schema,
        seatingType: SeatingTypes._meta.schema,
        seatingAmount: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'topId',
        'baseStyleId',
        'benchId',
        'baseType',
        'woodSpecies',
        'sheen',
        'seatingType',
        'seatingAmount'
    ]
});
const TopShape = new SchemaReflection('TopShape', {
    type: 'object',
    properties: {
        apronId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        },
        thicknessType: ThicknessesTypes._meta.schema,
        edgeStyle: EdgeStyles._meta.schema,
        distressLevel: DistressLevels._meta.schema,
        finish: Finishes._meta.schema,
        withGrooves: {
            type: 'boolean'
        },
        withCornerRadius: {
            type: 'boolean'
        },
        leafType: LeafTypes._meta.schema,
        leafAmount: {
            type: 'number'
        },
        thickness: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'apronId',
        'thicknessType',
        'edgeStyle',
        'distressLevel',
        'finish',
        'withGrooves',
        'withCornerRadius',
        'leafType',
        'leafAmount',
        'thickness'
    ]
});
const BaseShape = new SchemaReflection('BaseShape', {
    type: 'object',
    properties: {
        hasCrossbrace: {
            type: 'boolean'
        },
        finish: Finishes._meta.schema
    },
    additionalProperties: false,
    required: [
        'hasCrossbrace',
        'finish'
    ]
});
const TopWithWidthAndLengthShape = new SchemaReflection('TopWithWidthAndLengthShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number'
        },
        length: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'width',
        'length'
    ]
});
const TopWithSideShape = new SchemaReflection('TopWithSideShape', {
    type: 'object',
    properties: {
        side: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'side'
    ]
});
const TopWithDiameterShape = new SchemaReflection('TopWithDiameterShape', {
    type: 'object',
    properties: {
        diameter: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'diameter'
    ]
});
export const Table = new DomainEntityReflection('Table', [
    TableShape._meta.schema
]);
export const RectangleTop = new DomainEntityReflection('RectangleTop', [
    TopShape._meta.schema,
    TopWithWidthAndLengthShape._meta.schema
]);
export const SquareTop = new DomainEntityReflection('SquareTop', [
    TopShape._meta.schema,
    TopWithSideShape._meta.schema
]);
export const RoundTop = new DomainEntityReflection('RoundTop', [
    TopShape._meta.schema,
    TopWithDiameterShape._meta.schema
]);
export const EllipticalOvalTop = new DomainEntityReflection('EllipticalOvalTop', [
    TopShape._meta.schema,
    TopWithWidthAndLengthShape._meta.schema
]);
export const RacetrackOvalTop = new DomainEntityReflection('RacetrackOvalTop', [
    TopShape._meta.schema,
    TopWithWidthAndLengthShape._meta.schema
]);
export const BoatShapeTop = new DomainEntityReflection('BoatShapeTop', [
    TopShape._meta.schema,
    TopWithWidthAndLengthShape._meta.schema
]);
export const AnchorBase = new DomainEntityReflection('AnchorBase', [
    BaseShape._meta.schema
]);
export const AnchorSingleFeetBase = new DomainEntityReflection('AnchorSingleFeetBase', [
    BaseShape._meta.schema
]);
export const AnchorSinglePlatformBase = new DomainEntityReflection('AnchorSinglePlatformBase', [
    BaseShape._meta.schema
]);
export const BellhouseBase = new DomainEntityReflection('BellhouseBase', [
    BaseShape._meta.schema
]);
export const BellhouseSingleFeetBase = new DomainEntityReflection('BellhouseSingleFeetBase', [
    BaseShape._meta.schema
]);
export const BellhouseSinglePlatformBase = new DomainEntityReflection('BellhouseSinglePlatformBase', [
    BaseShape._meta.schema
]);
export const BellyStretchedBase = new DomainEntityReflection('BellyStretchedBase', [
    BaseShape._meta.schema
]);
export const BrewerBase = new DomainEntityReflection('BrewerBase', [
    BaseShape._meta.schema
]);
export const BrewerSingleBase = new DomainEntityReflection('BrewerSingleBase', [
    BaseShape._meta.schema
]);
export const CaseyBase = new DomainEntityReflection('CaseyBase', [
    BaseShape._meta.schema
]);
export const CraftsmanBase = new DomainEntityReflection('CraftsmanBase', [
    BaseShape._meta.schema
]);
export const CraftsmanSingleBase = new DomainEntityReflection('CraftsmanSingleBase', [
    BaseShape._meta.schema
]);
export const CrescentBase = new DomainEntityReflection('CrescentBase', [
    BaseShape._meta.schema
]);
export const CrescentSingleBase = new DomainEntityReflection('CrescentSingleBase', [
    BaseShape._meta.schema
]);
export const DanaBase = new DomainEntityReflection('DanaBase', [
    BaseShape._meta.schema
]);
export const DanaSingleBase = new DomainEntityReflection('DanaSingleBase', [
    BaseShape._meta.schema
]);
export const FranklinBase = new DomainEntityReflection('FranklinBase', [
    BaseShape._meta.schema
]);
export const FranklinSingleFeetBase = new DomainEntityReflection('FranklinSingleFeetBase', [
    BaseShape._meta.schema
]);
export const FranklinSinglePlatformBase = new DomainEntityReflection('FranklinSinglePlatformBase', [
    BaseShape._meta.schema
]);
export const MantisBase = new DomainEntityReflection('MantisBase', [
    BaseShape._meta.schema
]);
export const MarksBase = new DomainEntityReflection('MarksBase', [
    BaseShape._meta.schema
]);
export const MeredithBase = new DomainEntityReflection('MeredithBase', [
    BaseShape._meta.schema
]);
export const MeredithSingleFeetBase = new DomainEntityReflection('MeredithSingleFeetBase', [
    BaseShape._meta.schema
]);
export const MeredithSinglePlatformBase = new DomainEntityReflection('MeredithSinglePlatformBase', [
    BaseShape._meta.schema
]);
export const OswaldBase = new DomainEntityReflection('OswaldBase', [
    BaseShape._meta.schema
]);
export const OswaldSingleBase = new DomainEntityReflection('OswaldSingleBase', [
    BaseShape._meta.schema
]);
export const PeruStretchedBase = new DomainEntityReflection('PeruStretchedBase', [
    BaseShape._meta.schema
]);
export const RishBase = new DomainEntityReflection('RishBase', [
    BaseShape._meta.schema
]);
export const RishSingleBase = new DomainEntityReflection('RishSingleBase', [
    BaseShape._meta.schema
]);
export const RogersBase = new DomainEntityReflection('RogersBase', [
    BaseShape._meta.schema
]);
export const RogersSinglePlatformBase = new DomainEntityReflection('RogersSinglePlatformBase', [
    BaseShape._meta.schema
]);
export const TamaraBase = new DomainEntityReflection('TamaraBase', [
    BaseShape._meta.schema
]);
export const TamaraSingleBase = new DomainEntityReflection('TamaraSingleBase', [
    BaseShape._meta.schema
]);
export const TuscanBase = new DomainEntityReflection('TuscanBase', [
    BaseShape._meta.schema
]);
export const TuscanSingleFeetBase = new DomainEntityReflection('TuscanSingleFeetBase', [
    BaseShape._meta.schema
]);
export const TuscanSinglePlatformBase = new DomainEntityReflection('TuscanSinglePlatformBase', [
    BaseShape._meta.schema
]);
export const WaldenBase = new DomainEntityReflection('WaldenBase', [
    BaseShape._meta.schema
]);
export const WaldenSingleBase = new DomainEntityReflection('WaldenSingleBase', [
    BaseShape._meta.schema
]);
export const AnglePictureFrameBase = new DomainEntityReflection('AnglePictureFrameBase', [
    BaseShape._meta.schema
]);
export const XBase = new DomainEntityReflection('XBase', [
    BaseShape._meta.schema
]);
export const XSingleBase = new DomainEntityReflection('XSingleBase', [
    BaseShape._meta.schema
]);
export const AnglePictureFrameSingleBase = new DomainEntityReflection('AnglePictureFrameSingleBase', [
    BaseShape._meta.schema
]);
export const AnglePictureFrameCTCBase = new DomainEntityReflection('AnglePictureFrameCTCBase', [
    BaseShape._meta.schema
]);
export const ArchBase = new DomainEntityReflection('ArchBase', [
    BaseShape._meta.schema
]);
export const ArchSingleBase = new DomainEntityReflection('ArchSingleBase', [
    BaseShape._meta.schema
]);
export const BoxFrameBase = new DomainEntityReflection('BoxFrameBase', [
    BaseShape._meta.schema
]);
export const ConnectedXBase = new DomainEntityReflection('ConnectedXBase', [
    BaseShape._meta.schema
]);
export const SlimConnectedXBase = new DomainEntityReflection('SlimConnectedXBase', [
    BaseShape._meta.schema
]);
export const SlimConnectedXSingleBase = new DomainEntityReflection('SlimConnectedXSingleBase', [
    BaseShape._meta.schema
]);
export const ReflectionBase = new DomainEntityReflection('ReflectionBase', [
    BaseShape._meta.schema
]);
export const ReflectionCTCBase = new DomainEntityReflection('ReflectionCTCBase', [
    BaseShape._meta.schema
]);
export const SinglePostBase = new DomainEntityReflection('SinglePostBase', [
    BaseShape._meta.schema
]);
export const SinglePostSingleBase = new DomainEntityReflection('SinglePostSingleBase', [
    BaseShape._meta.schema
]);
export const XMetalBase = new DomainEntityReflection('XMetalBase', [
    BaseShape._meta.schema
]);
export const XMetalSingleBase = new DomainEntityReflection('XMetalSingleBase', [
    BaseShape._meta.schema
]);
export const IvyBase = new DomainEntityReflection('IvyBase', [
    BaseShape._meta.schema
]);
export const DremorTurnedBase = new DomainEntityReflection('DremorTurnedBase', [
    BaseShape._meta.schema
]);
export const HerricksonTurnedBase = new DomainEntityReflection('HerricksonTurnedBase', [
    BaseShape._meta.schema
]);
export const MidModernTaperBase = new DomainEntityReflection('MidModernTaperBase', [
    BaseShape._meta.schema
]);
export const NarrowEnglishTurnedBase = new DomainEntityReflection('NarrowEnglishTurnedBase', [
    BaseShape._meta.schema
]);
export const OldEnglishTurnedBase = new DomainEntityReflection('OldEnglishTurnedBase', [
    BaseShape._meta.schema
]);
export const SlagleTurnedBase = new DomainEntityReflection('SlagleTurnedBase', [
    BaseShape._meta.schema
]);
export const TraditionalBase = new DomainEntityReflection('TraditionalBase', [
    BaseShape._meta.schema
]);
export const TraditionalFlushBase = new DomainEntityReflection('TraditionalFlushBase', [
    BaseShape._meta.schema
]);
export const ReededBase = new DomainEntityReflection('ReededBase', [
    BaseShape._meta.schema
]);
export const HershBase = new DomainEntityReflection('HershBase', [
    BaseShape._meta.schema
]);
export const TriflectionBase = new DomainEntityReflection('TriflectionBase', [
    BaseShape._meta.schema
]);
export const ApronBasic = new DomainEntityReflection('ApronBasic', []);
export const ApronNone = new DomainEntityReflection('ApronNone', []);
export const BenchBasic = new DomainEntityReflection('BenchBasic', []);
export const AnyDomainEntity = new RawAliasReflection('AnyDomainEntity', [
    Table,
    RectangleTop,
    SquareTop,
    RoundTop,
    EllipticalOvalTop,
    RacetrackOvalTop,
    BoatShapeTop,
    AnchorBase,
    AnchorSingleFeetBase,
    AnchorSinglePlatformBase,
    BellhouseBase,
    BellhouseSingleFeetBase,
    BellhouseSinglePlatformBase,
    BellyStretchedBase,
    BrewerBase,
    BrewerSingleBase,
    CaseyBase,
    CraftsmanBase,
    CraftsmanSingleBase,
    CrescentBase,
    CrescentSingleBase,
    DanaBase,
    DanaSingleBase,
    FranklinBase,
    FranklinSingleFeetBase,
    FranklinSinglePlatformBase,
    MantisBase,
    MarksBase,
    MeredithBase,
    MeredithSingleFeetBase,
    MeredithSinglePlatformBase,
    OswaldBase,
    OswaldSingleBase,
    PeruStretchedBase,
    RishBase,
    RishSingleBase,
    RogersBase,
    RogersSinglePlatformBase,
    TamaraBase,
    TamaraSingleBase,
    TuscanBase,
    TuscanSingleFeetBase,
    TuscanSinglePlatformBase,
    WaldenBase,
    WaldenSingleBase,
    AnglePictureFrameBase,
    XBase,
    XSingleBase,
    AnglePictureFrameSingleBase,
    AnglePictureFrameCTCBase,
    ArchBase,
    ArchSingleBase,
    BoxFrameBase,
    ConnectedXBase,
    SlimConnectedXBase,
    SlimConnectedXSingleBase,
    ReflectionBase,
    ReflectionCTCBase,
    SinglePostBase,
    SinglePostSingleBase,
    XMetalBase,
    XMetalSingleBase,
    IvyBase,
    DremorTurnedBase,
    HerricksonTurnedBase,
    MidModernTaperBase,
    NarrowEnglishTurnedBase,
    OldEnglishTurnedBase,
    SlagleTurnedBase,
    TraditionalBase,
    TraditionalFlushBase,
    ReededBase,
    HershBase,
    TriflectionBase,
    ApronBasic,
    ApronNone,
    BenchBasic
]);
export const RootEntity = new RawAliasReflection('RootEntity', [
    Table
]);
export const Top = new RawAliasReflection('Top', [
    RectangleTop,
    SquareTop,
    RoundTop,
    EllipticalOvalTop,
    RacetrackOvalTop,
    BoatShapeTop
]);
export const Base = new RawAliasReflection('Base', [
    AnchorBase,
    AnchorSingleFeetBase,
    AnchorSinglePlatformBase,
    BellhouseBase,
    BellhouseSingleFeetBase,
    BellhouseSinglePlatformBase,
    BellyStretchedBase,
    BrewerBase,
    BrewerSingleBase,
    CaseyBase,
    CraftsmanBase,
    CraftsmanSingleBase,
    CrescentBase,
    CrescentSingleBase,
    DanaBase,
    DanaSingleBase,
    FranklinBase,
    FranklinSingleFeetBase,
    FranklinSinglePlatformBase,
    MantisBase,
    MarksBase,
    MeredithBase,
    MeredithSingleFeetBase,
    MeredithSinglePlatformBase,
    OswaldBase,
    OswaldSingleBase,
    PeruStretchedBase,
    RishBase,
    RishSingleBase,
    RogersBase,
    RogersSinglePlatformBase,
    TamaraBase,
    TamaraSingleBase,
    TuscanBase,
    TuscanSingleFeetBase,
    TuscanSinglePlatformBase,
    WaldenBase,
    WaldenSingleBase,
    XBase,
    XSingleBase,
    AnglePictureFrameBase,
    AnglePictureFrameSingleBase,
    AnglePictureFrameCTCBase,
    ArchBase,
    ArchSingleBase,
    BoxFrameBase,
    ConnectedXBase,
    SlimConnectedXBase,
    SlimConnectedXSingleBase,
    ReflectionBase,
    ReflectionCTCBase,
    SinglePostBase,
    SinglePostSingleBase,
    XMetalBase,
    XMetalSingleBase,
    IvyBase,
    DremorTurnedBase,
    HerricksonTurnedBase,
    MidModernTaperBase,
    NarrowEnglishTurnedBase,
    OldEnglishTurnedBase,
    SlagleTurnedBase,
    TraditionalBase,
    TraditionalFlushBase,
    ReededBase,
    HershBase,
    TriflectionBase
]);
export const Apron = new RawAliasReflection('Apron', [
    ApronBasic,
    ApronNone
]);
export const Bench = new RawAliasReflection('Bench', [
    BenchBasic
]);
export const TopOval = new RawAliasReflection('TopOval', [
    EllipticalOvalTop,
    RacetrackOvalTop
]);
export const TopWithSide = new RawAliasReflection('TopWithSide', [
    SquareTop
]);
export const TopWithWidthAndLength = new RawAliasReflection('TopWithWidthAndLength', [
    RectangleTop,
    EllipticalOvalTop,
    RacetrackOvalTop,
    BoatShapeTop
]);
export const TopWithDiameter = new RawAliasReflection('TopWithDiameter', [
    RoundTop
]);
export const TopWithRolledThickness = new RawAliasReflection('TopWithRolledThickness', [
    RectangleTop,
    SquareTop
]);
export const BasePedestal = new RawAliasReflection('BasePedestal', [
    AnchorBase,
    AnchorSingleFeetBase,
    AnchorSinglePlatformBase,
    BellhouseBase,
    BellhouseSingleFeetBase,
    BellhouseSinglePlatformBase,
    BellyStretchedBase,
    BrewerBase,
    BrewerSingleBase,
    CaseyBase,
    CraftsmanBase,
    CraftsmanSingleBase,
    CrescentBase,
    CrescentSingleBase,
    DanaBase,
    DanaSingleBase,
    FranklinBase,
    FranklinSingleFeetBase,
    FranklinSinglePlatformBase,
    MarksBase,
    MeredithBase,
    MeredithSingleFeetBase,
    MeredithSinglePlatformBase,
    OswaldBase,
    OswaldSingleBase,
    PeruStretchedBase,
    RishBase,
    RishSingleBase,
    RogersBase,
    RogersSinglePlatformBase,
    TamaraBase,
    TamaraSingleBase,
    TuscanBase,
    TuscanSingleFeetBase,
    TuscanSinglePlatformBase,
    WaldenBase,
    WaldenSingleBase,
    XBase,
    XSingleBase,
    ReededBase,
    HershBase
]);
export const BaseMetal = new RawAliasReflection('BaseMetal', [
    MantisBase,
    AnglePictureFrameBase,
    AnglePictureFrameSingleBase,
    AnglePictureFrameCTCBase,
    ArchBase,
    ArchSingleBase,
    BoxFrameBase,
    ConnectedXBase,
    SlimConnectedXBase,
    SlimConnectedXSingleBase,
    ReflectionBase,
    ReflectionCTCBase,
    SinglePostBase,
    SinglePostSingleBase,
    XMetalBase,
    XMetalSingleBase,
    TriflectionBase
]);
export const BaseFourLeg = new RawAliasReflection('BaseFourLeg', [
    IvyBase,
    DremorTurnedBase,
    HerricksonTurnedBase,
    MidModernTaperBase,
    NarrowEnglishTurnedBase,
    OldEnglishTurnedBase,
    SlagleTurnedBase,
    TraditionalBase,
    TraditionalFlushBase
]);
export const BaseSingleLeg = new RawAliasReflection('BaseSingleLeg', [
    BellyStretchedBase,
    BrewerSingleBase,
    AnchorSingleFeetBase,
    AnchorSinglePlatformBase,
    BellhouseSingleFeetBase,
    BellhouseSinglePlatformBase,
    CraftsmanSingleBase,
    CrescentSingleBase,
    DanaSingleBase,
    FranklinSingleFeetBase,
    FranklinSinglePlatformBase,
    MantisBase,
    MarksBase,
    MeredithSingleFeetBase,
    MeredithSinglePlatformBase,
    OswaldSingleBase,
    PeruStretchedBase,
    RishSingleBase,
    RogersSinglePlatformBase,
    TamaraSingleBase,
    TuscanSingleFeetBase,
    TuscanSinglePlatformBase,
    WaldenSingleBase,
    XSingleBase,
    AnglePictureFrameSingleBase,
    AnglePictureFrameCTCBase,
    ArchSingleBase,
    SlimConnectedXSingleBase,
    ReflectionBase,
    ReflectionCTCBase,
    SinglePostSingleBase,
    XMetalSingleBase,
    ReededBase
]);
export const BaseDoubleLeg = new RawAliasReflection('BaseDoubleLeg', [
    AnchorBase,
    BellhouseBase,
    BrewerBase,
    CaseyBase,
    CraftsmanBase,
    CrescentBase,
    DanaBase,
    FranklinBase,
    MeredithBase,
    OswaldBase,
    RishBase,
    RogersBase,
    TamaraBase,
    TuscanBase,
    WaldenBase,
    XBase,
    AnglePictureFrameBase,
    ArchBase,
    BoxFrameBase,
    ConnectedXBase,
    SlimConnectedXBase,
    SinglePostBase,
    XMetalBase,
    HershBase,
    TriflectionBase
]);
export const BaseWithPlatform = new RawAliasReflection('BaseWithPlatform', [
    AnchorSinglePlatformBase,
    BellhouseSinglePlatformBase,
    BellyStretchedBase,
    FranklinSinglePlatformBase,
    MeredithSinglePlatformBase,
    TuscanSinglePlatformBase,
    PeruStretchedBase,
    RogersSinglePlatformBase
]);
export const BaseFourLegCombined = new RawAliasReflection('BaseFourLegCombined', [
    IvyBase
]);
export const BaseFourLegSeparate = new RawAliasReflection('BaseFourLegSeparate', [
    DremorTurnedBase,
    HerricksonTurnedBase,
    MidModernTaperBase,
    NarrowEnglishTurnedBase,
    OldEnglishTurnedBase,
    SlagleTurnedBase,
    TraditionalBase,
    TraditionalFlushBase
]);
export const TopWithSquareCorners = new RawAliasReflection('TopWithSquareCorners', [
    RectangleTop,
    SquareTop
]);
export const TopWithRoundedCorners = new RawAliasReflection('TopWithRoundedCorners', [
    RoundTop,
    EllipticalOvalTop,
    RacetrackOvalTop,
    BoatShapeTop
]);
export const StretchedBase = new RawAliasReflection('StretchedBase', [
    BellyStretchedBase,
    PeruStretchedBase
]);
export const aliases = {
    AnyDomainEntity: AnyDomainEntity.types,
    RootEntity: RootEntity.types,
    Top: Top.types,
    Base: Base.types,
    Apron: Apron.types,
    Bench: Bench.types,
    TopOval: TopOval.types,
    TopWithSide: TopWithSide.types,
    TopWithWidthAndLength: TopWithWidthAndLength.types,
    TopWithDiameter: TopWithDiameter.types,
    TopWithRolledThickness: TopWithRolledThickness.types,
    BasePedestal: BasePedestal.types,
    BaseMetal: BaseMetal.types,
    BaseFourLeg: BaseFourLeg.types,
    BaseSingleLeg: BaseSingleLeg.types,
    BaseDoubleLeg: BaseDoubleLeg.types,
    BaseWithPlatform: BaseWithPlatform.types,
    BaseFourLegCombined: BaseFourLegCombined.types,
    BaseFourLegSeparate: BaseFourLegSeparate.types,
    TopWithSquareCorners: TopWithSquareCorners.types,
    TopWithRoundedCorners: TopWithRoundedCorners.types,
    StretchedBase: StretchedBase.types
};
export const entities = {
    Table,
    RectangleTop,
    SquareTop,
    RoundTop,
    EllipticalOvalTop,
    RacetrackOvalTop,
    BoatShapeTop,
    AnchorBase,
    AnchorSingleFeetBase,
    AnchorSinglePlatformBase,
    BellhouseBase,
    BellhouseSingleFeetBase,
    BellhouseSinglePlatformBase,
    BellyStretchedBase,
    BrewerBase,
    BrewerSingleBase,
    CaseyBase,
    CraftsmanBase,
    CraftsmanSingleBase,
    CrescentBase,
    CrescentSingleBase,
    DanaBase,
    DanaSingleBase,
    FranklinBase,
    FranklinSingleFeetBase,
    FranklinSinglePlatformBase,
    MantisBase,
    MarksBase,
    MeredithBase,
    MeredithSingleFeetBase,
    MeredithSinglePlatformBase,
    OswaldBase,
    OswaldSingleBase,
    PeruStretchedBase,
    RishBase,
    RishSingleBase,
    RogersBase,
    RogersSinglePlatformBase,
    TamaraBase,
    TamaraSingleBase,
    TuscanBase,
    TuscanSingleFeetBase,
    TuscanSinglePlatformBase,
    WaldenBase,
    WaldenSingleBase,
    AnglePictureFrameBase,
    XBase,
    XSingleBase,
    AnglePictureFrameSingleBase,
    AnglePictureFrameCTCBase,
    ArchBase,
    ArchSingleBase,
    BoxFrameBase,
    ConnectedXBase,
    SlimConnectedXBase,
    SlimConnectedXSingleBase,
    ReflectionBase,
    ReflectionCTCBase,
    SinglePostBase,
    SinglePostSingleBase,
    XMetalBase,
    XMetalSingleBase,
    IvyBase,
    DremorTurnedBase,
    HerricksonTurnedBase,
    MidModernTaperBase,
    NarrowEnglishTurnedBase,
    OldEnglishTurnedBase,
    SlagleTurnedBase,
    TraditionalBase,
    TraditionalFlushBase,
    ReededBase,
    HershBase,
    TriflectionBase,
    ApronBasic,
    ApronNone,
    BenchBasic
};

//# sourceMappingURL=v1.js.map